import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import './widgetBox.pcss'

export default class WidgetBox extends PureComponent {
  render() {
    const {
      className,
      title,
      linkTo,
      linkToHelpText,
      widgetId,
      children,
    } = this.props

    return (
      <section className={ classnames('widget-box', className) }>
        { linkTo ? (
          <h3 className='widget-box__header' id={ widgetId }>
            <Link to={ linkTo } title={ linkToHelpText }>
              <span>{ title }</span>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width='19' height='19' aria-hidden='true' className='widget-box__header__icon'>
                <circle cx='100' cy='100' r='80' fill='none' stroke='#fff' strokeWidth='14' />
                <line x1='85' y1='70' x2='120' y2='100' stroke='#fff' strokeWidth='12' />
                <line x1='85' y1='130' x2='120' y2='100' stroke='#fff' strokeWidth='12' />
              </svg>
            </Link>
          </h3>
        ) : (
          <h3 className='widget-box__header' id={ widgetId }>
            { title }
          </h3>
        ) }
        <div className='widget-box__content'>
          { children }
        </div>
      </section>
    )
  }
}


WidgetBox.propTypes = exact({
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  linkTo: PropTypes.string,
  linkToHelpText: PropTypes.string,
  widgetId: PropTypes.string,
  className: PropTypes.string,
})
